/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li4_BInputs */

const tr_mesafeli_s20_li4_b = /** @type {(inputs: Mesafeli_S20_Li4_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` altında kayıtlıdır; kayıt sorgulaması`)
};

const en_mesafeli_s20_li4_b = /** @type {(inputs: Mesafeli_S20_Li4_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; the registry lookup is available at`)
};

const de_mesafeli_s20_li4_b = /** @type {(inputs: Mesafeli_S20_Li4_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` eingetragen; die Registerabfrage ist`)
};

const ru_mesafeli_s20_li4_b = /** @type {(inputs: Mesafeli_S20_Li4_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; проверка регистрации доступна по адресу`)
};

/**
* | output |
* | --- |
* | "; the registry lookup is available at" |
*
* @param {Mesafeli_S20_Li4_BInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li4_b = /** @type {((inputs?: Mesafeli_S20_Li4_BInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li4_BInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li4_b(inputs)
	if (locale === "de") return de_mesafeli_s20_li4_b(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li4_b(inputs)
	return tr_mesafeli_s20_li4_b(inputs)
});